import { apiFetch } from '@/lib/api/client';

/**
 * 내 프로필 사진 업로드.
 *
 * 인사관리 화면의 같은 기능(`pages/hr/personnelPhoto.ts`)과 경로가 다르다 — 이쪽은 <b>인력 id 를
 * 보내지 않는다</b>. 대상은 서버가 세션에서 정하므로 남의 사진을 바꿀 방법이 없고, 그래서 인사 메뉴
 * 권한 없이도 열린다. 자기 얼굴을 바꾸려고 인사팀에 부탁하게 만들지 않으려는 것이 이 경로의 이유다.
 *
 * 올리는 방식은 같다 — presigned PUT URL 을 받아 스토리지에 직접 올리고 서버에는 키만 보낸다.
 */
export async function uploadMyPhoto(file: File): Promise<string> {
  const { key, url } = await apiFetch<{ key: string; url: string }>('/v1/home/profile/photo-uploads', {
    method: 'POST',
    body: { fileName: file.name },
  });

  const put = await fetch(url, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': file.type || 'application/octet-stream' },
  });
  if (!put.ok) {
    throw new Error('사진 업로드에 실패했습니다.');
  }
  return key;
}

/**
 * 내 프로필 사진 지정·해제. `objectKey` 가 null 이면 내린다.
 *
 * @returns 새 사진의 내려받기 링크(내렸으면 null)
 */
export function changeMyPhoto(objectKey: string | null): Promise<string | null> {
  return apiFetch<string | null>('/v1/home/profile/photo', { method: 'PUT', body: { objectKey } });
}
